import { memo } from 'react';

import ZoomInIconSVG from '@/assets/zoom-in-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IZoomInIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={ZoomInIconSVG} {...props} />;

export const ZoomInIcon = memo(IZoomInIcon) as typeof IZoomInIcon;
